import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/integrations')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
